import { BaseRouteService } from "./BaseRouteService";

export class TravelMapService extends BaseRouteService {
    /**
     * Verzend een verzoek om naar een andere kamer te reizen.
     *
     * @param location De naam van de kamer om naar toe te reizen
     */
    public async travelToLocation(location: string): Promise<void> {
        try {
            // Stel het verzoek samen naar de server om de speler naar een nieuwe kamer te verplaatsen
            const response: Response = await this.postJsonApi(`erwin/travel/${location}`, {});

            // Verwerk de serverresponse hier, bijvoorbeeld door de spelerstatus bij te werken
            console.log("Server response:", response);
        }
        catch (error) {
            console.error("Fout tijdens reizen:", error);
        }
    }

    /**
    * Haal een lijst op van bezochte kamers vanuit de backend.
    *
    * @returns Een array van bezochte kamers.
    */
    public async getVisitedRooms(): Promise<string[]> {
        try {
            const visitedRooms: string[] = await this.getJsonApi("erwin/visitedRooms"); // Direct de array ophalen

            return visitedRooms;
        }
        catch (error) {
            console.error("Fout bij ophalen van bezochte kamers:", error);
            return []; // Geef een lege array terug als er een fout is
        }
    }
}
